class SmartGeocodeCollection extends App.Collections.BaseCollection {
    url = 'SmartGeocode';
    model = App.Models.SmartGeocode;

    getPositionByLocationId = (locationId) => {
        var typeOfLocationId = typeof locationId;

        if (typeOfLocationId !== "undefined") {
            var length = this.size();

            if (typeOfLocationId === "string") {
                locationId = parseInt(locationId, 10);
            }

            for (var i = 0; i < length; i++) {
                var model = this.at(i);
                var modelLocationId = model.get("locationId");

                if (locationId === modelLocationId) {
                    return i;
                }
            }
        }
        return false;
    }
}

App.Collections.SmartGeocode = SmartGeocodeCollection;
